import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { rolesApi as r } from "@maat/api-main";
//#region src/workspaces/useAssignRoleMutation.ts
var i = (i) => {
	let a = n();
	return t({
		mutationFn: (e) => r.assignRole(i, e.userId),
		onSuccess: () => {
			a.invalidateQueries({ queryKey: e.roleMembers(i) }), a.invalidateQueries({ queryKey: e.members() }), a.invalidateQueries({ queryKey: e.roles() }), a.invalidateQueries({ queryKey: e.role(i) });
		}
	});
};
//#endregion
export { i as useAssignRoleMutation };
